export const UNAVAILABLE_DATE_COLOR = 'rgba(0, 0, 0, 0.25)';
export const UNAVAILABLE_DATE_BACKGROUND = 'rgb(255, 255, 255)';
export const AVAILABLE_DATE_COLOR = 'rgb(255, 255, 255)';
export const AVAILABLE_DATE_BACKGROUND = 'rgb(76, 145, 255)';
